import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
// import Grid from '@material-ui/core/Grid';
import App from './App'
import Timer from './Timer'
import Intro from './Intro'
import NameInput from './NameInput'
import StartButton from './QuizButtons/StartButton'

const red = '#bb0000';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    backgroundColor:'#ffffff',
  },
  appFrame: {
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    width: '100%',
    backgroundColor: red,
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    height: '100%',
  },
});

class QuizDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDone: false,
      time: 0,
      start: 0,
      duration : 80 * 60,
      timer:null,
      nameInputed: false,
      name: "",
    }
    this.setDone = this.setDone.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.nameHandler = this.nameHandler.bind(this);
  }

  startTimer() {
    const timerId = setInterval(() => {
      this.setState({
        time: Date.now() - this.state.start
      })
      if (this.state.time > (this.state.duration) * 1000) {
        this.props.finishFunk()
        this.stopTimer()
      }
    }, 1000);
    this.setState({
      start: new Date(),
      intervalId: timerId,
    })
  }

  stopTimer(){
    clearInterval(this.state.intervalId)
  }

  setDone(){
    this.setState({
      hasDone: true
    })
  }

  componentWillReceiveProps(nextProps){
    if((nextProps.started) && (!this.props.hasDone) && (this.state.start === 0)){
      this.startTimer();
    }
  }

  nameHandler(name) {
    this.setState({
      nameInputed: true,
      name: name,
    })
    this.props.NameInputHandler(name)
  }



  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          <AppBar
            position="absolute"
            className={classes.appBar}
          />

          <main className={classes.content}>
          { this.state.nameInputed ? null : <NameInput enterHandler={this.nameHandler} /> }
          { this.props.hasDone || !this.props.started ? null : <Timer time={this.state.time} duration={this.state.duration} /> }
          { this.props.started ? <App hasDone={this.props.hasDone} finishButtonFunc={this.props.finishFunk} endTimer={this.stopTimer} startDate={this.props.startDate} /> : null }
          { this.state.nameInputed && !this.props.started ? <Intro /> : null}
          { this.state.nameInputed && !this.props.started ?  <StartButton clickFunc={this.props.clickFunc} /> : null }
          </main>
        </div>
      </div>
    );
  }
}

QuizDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  started: PropTypes.bool.isRequired,
  hasDone: PropTypes.bool.isRequired,
  clickFunc:PropTypes.func.isRequired,
  finishFunk: PropTypes.func.isRequired,
};

export default withStyles(styles)(QuizDrawer);



// WEBPACK FOOTER //
// ./src/components/quiz/QuizDrawer.js